import React from "react";
import ReactDOM from "react-dom";
import { Analytics } from "@vercel/analytics/react";
import "./stylesheet.css";
import AppRouter from "./router/AppRouter";
import { AppProvider } from "./context";
ReactDOM.render(
  <AppProvider>
    <AppRouter />
    <Analytics />
  </AppProvider>,
  document.getElementById("root"),
);
